import { AnalyticsData } from '@domgen/dgx-fe-business-models';
import { MonoTypeOperatorFunction, pipe } from 'rxjs';
import { filter } from 'rxjs/operators';

export const filterFieldCompletion =
  (): MonoTypeOperatorFunction<AnalyticsData> => {
    return pipe(filter((analyticsData) => !analyticsData.error));
  };
